var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailedNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 42"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 13",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FFD5D5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9937 12.693L8.8347 15.8519C8.73234 15.9543 8.62217 16.0036 8.50417 15.9998C8.38618 15.996 8.27364 15.9406 8.16654 15.8335C8.05943 15.7264 8.00588 15.6119 8.00588 15.4901C8.00588 15.3684 8.05943 15.2539 8.16654 15.1468L11.307 12.0063L8.14806 8.8473C8.04569 8.74495 7.99641 8.63169 8.0002 8.50753C8.00399 8.38338 8.05943 8.26776 8.16654 8.16066C8.27364 8.05355 8.38808 8 8.50986 8C8.63164 8 8.74608 8.05355 8.85318 8.16066L11.9937 11.3196L15.1527 8.16066C15.2551 8.0583 15.3683 8.00593 15.4925 8.00357C15.6166 8.00119 15.7322 8.05355 15.8393 8.16066C15.9464 8.26776 16 8.3822 16 8.50398C16 8.62577 15.9464 8.74021 15.8393 8.8473L12.6804 12.0063L15.8393 15.1653C15.9417 15.2677 15.9941 15.3778 15.9964 15.4958C15.9988 15.6138 15.9464 15.7264 15.8393 15.8335C15.7322 15.9406 15.6178 15.9941 15.496 15.9941C15.3742 15.9941 15.2598 15.9406 15.1527 15.8335L11.9937 12.693Z",
    fill: "#F32121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedNotificationIcon);
export default __webpack_public_path__ + "static/media/failedNotificationIcon.5c568ce5a3e3cc8f40fa14aa4db0ddb1.svg";
export { ForwardRef as ReactComponent };